import { takeLatest, put, call, select } from 'redux-saga/effects';

import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import { NEWS_DETAILS_GET, NEWS_LIST_GET } from '../actions/news';
import news from '../../api/news';

function* newsListGet({ filters, isPublic = false }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { authState: { isLogged } = {} } = yield select((state) => state.app);
    const { data: { data: response } = {} } = yield call(news.newsListGet, {
      filters: { ...filters },
      isLogged,
      isPublic,
    });
    yield put({ type: NEWS_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > news > newsListGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* newsListGetWatch() {
  yield takeLatest(NEWS_LIST_GET._REQUEST, newsListGet);
}

function* newsDetailsGet({ id, isPublic = false }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { authState: { isLogged } = {} } = yield select((state) => state.app);
    const { data: { data: response } = {} } = yield call(news.newsDetailsGet, {
      id,
      isLogged,
      isPublic,
    });
    yield put({ type: NEWS_DETAILS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > news > newsDetailsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* newsDetailsGetWatch() {
  yield takeLatest(NEWS_DETAILS_GET._REQUEST, newsDetailsGet);
}

export default [newsListGetWatch(), newsDetailsGetWatch()];
